import { TableFooter, TablePagination, TableRow } from "@mui/material";
import React from "react";
import i18n from "../i18n-config";
import { capitalizeFirstLetter } from "../utils/strings";

interface Props {
  rowsPerPage: any;
  data: any;
  page: any;
  handleChangePage: any;
  handleChangeRowsPerPage: any;
}

const CustomTableFooter: React.FC<Props> = ({
  rowsPerPage,
  data,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={[
            10,
            25,
            50,
            100,
            { label: i18n.t("all"), value: -1 },
          ]}
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "",
            },
            native: true,
          }}
          sx={{ border: "none" }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={capitalizeFirstLetter(i18n.t("rows_per_page"))}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}–${to} ${i18n.t("of")} ${
              count !== -1 ? count : `${i18n.t("more_than")} ${to}`
            }`
          }
        />
      </TableRow>
    </TableFooter>
  );
};

export default CustomTableFooter;
